module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Bold-1d010464.eot";